import viaCEP from './viaCEP'

const externalAPIs = {
  viaCEP,
}

export default externalAPIs
